module.exports = __webpack_public_path__ + "static/a-xx-114-art-116e1bcfa1e4ea09317daaa77451aab1.jpg";